import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiService, UtilService } from '.';
import {
  AMOUNT_OPERATORS,
  CONTROLLERS,
  ENDPOINTS,
  FREQUENCY_IN_MINUTES,
  PAY_NOW_LOOKUP_TYPE,
  PAYMENT_AGES,
  PAYMENT_STATUSES,
  PAYMENT_STATUSES_FILTER,
  PROCESSORS,
  USER_ROLES,
} from '../constants';
import { GraphsDetails, KPIDashboardTile, PMSType, ProcessorDetails, Response, State } from '../models';
import { PROCESSORS_TYPE } from '../constants/processors.constant';
import { PMSVersion } from '../models/pms-versions.models';
@Injectable({
  providedIn: 'root',
})
export class PickListService {
  private api: string = CONTROLLERS.PICK_LIST;
  constructor(
    private apiService: ApiService,
    public _utilService: UtilService
  ) {}

  getStates(country: string): Observable<Response<State[]>> {
    return this.apiService.get(`${this.api}/${ENDPOINTS.PICK_LIST.GET_STATES}/${country}`);
  }

  getUserRoles(): Observable<any> {
    return new BehaviorSubject(
      this._utilService.generateDropdownValuesFromEnum(USER_ROLES)
    ).asObservable();
  }

  getPMSTypes(): Observable<Response<PMSType[]>> {
    return this.apiService.get(`${this.api}/${ENDPOINTS.PICK_LIST.GET_PMS}`);
  }

  getProcessors(): Observable<any> {
    return new BehaviorSubject(
      this._utilService.generateDropdownValuesFromEnum(PROCESSORS)
    ).asObservable();
  }

  getProcessorTypes(): Observable<any> {
    return new BehaviorSubject(
      this._utilService.generateDropdownValuesFromEnum(PROCESSORS_TYPE)
    ).asObservable();
  }

  getPaymentAges(): Observable<any> {
    return new BehaviorSubject(
      this._utilService.generateDropdownValuesFromEnum(PAYMENT_AGES)
    ).asObservable();
  }

  getPaymentStatuses(): Observable<any> {
    return new BehaviorSubject(
      this._utilService.generateDropdownValuesFromEnum(PAYMENT_STATUSES)
    ).asObservable();
  }

  getPaymentStatusesFilter(): Observable<any> {
    return new BehaviorSubject(
      this._utilService.generateDropdownValuesFromEnum(PAYMENT_STATUSES_FILTER)
    ).asObservable();
  }

  getAmountOperators(): Observable<any> {
    return new BehaviorSubject(
      this._utilService.generateDropdownValuesFromEnum(AMOUNT_OPERATORS)
    ).asObservable();
  }

  getFrequencyInMinutes(): Observable<any> {
    return new BehaviorSubject(
      this._utilService.generateDropdownValuesFromEnum(FREQUENCY_IN_MINUTES)
    ).asObservable();
  }

  getMasterKPIDashboardTile(): Observable<Response<KPIDashboardTile[]>> {
    return this.apiService.get(`${this.api}/${ENDPOINTS.PICK_LIST.GET_MASTER_KPI_DASHBOARD_TILE}`);
  }

  getMasterGraphs(): Observable<Response<GraphsDetails[]>> {
    return this.apiService.get(`${this.api}/${ENDPOINTS.PICK_LIST.GET_MASTER_GRAPH}`);
  }

  getPayNowLookUpType(): Observable<any> {
    return new BehaviorSubject(
      this._utilService.generateDropdownValuesFromEnum(PAY_NOW_LOOKUP_TYPE)
    ).asObservable();
  }

  getPMSVersions(pmsId: number): Observable<Response<PMSVersion[]>> {
    return this.apiService.post(`${this.api}/${ENDPOINTS.PICK_LIST.GET_PMS_VERSIONS}`,
      { pmsId }
    );
  }
}
